module.exports = __webpack_public_path__ + "img/building.3bf28bf7.png";